import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontMerriweather, fontRoboto, fontRobotoCondensed } from "shared/lib/styles";

import { SignUpButton } from "scmp-app/components/newsletter/sign-up-button";

import IconClock from "./icon-clock.svg";

export const StyledIconClock = styled(IconClock)`
  inline-size: 18px;
  block-size: 18px;
  margin: 3px;
`;

export const StyledBaseLink = styled(BaseLink)`
  display: flex;
  gap: 8px;
  justify-content: start;
  align-items: center;

  cursor: pointer;
`;

export const Header = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: flex-start;
  align-items: center;

  inline-size: 100%;
  padding-block: 4px;
  padding-inline: 20px;

  color: #ffffff;
  color: #001246;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 22px;

  background: #dae7ff;
`;

export const NewsletterLabel = styled.span`
  color: #001246;
  font-weight: 600;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 22px;
`;

export const Title = styled.span`
  display: flex;
  gap: 4px;

  margin-inline-start: auto;

  text-transform: uppercase;
`;

export const FooterText = styled.div``;

export const FooterTitle = styled.div`
  font-size: 18px;
`;

export const Summary = styled.div`
  display: flex;
  gap: 8px;
  justify-content: start;
  align-items: center;

  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const StyledSignUpButton = styled(SignUpButton)`
  align-self: flex-start;

  inline-size: 100%;

  font-size: 14px;
  font-family: ${fontRoboto};
`;

export const MyNewsButton = styled(BaseLink)`
  align-self: flex-start;

  inline-size: 100%;
  padding-block: 8px;
  padding-inline: 12px;

  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
  text-align: center;
  text-transform: uppercase;

  border-radius: 2px;

  background: #4585ff;
`;

export const Footer = styled.div`
  position: fixed;
  inset-block-end: 0;

  display: grid;
  flex-flow: row;
  grid-template:
    "Text SignUpButton" min-content
    ". SignUpButton" 4px
    "Title SignUpButton" min-content
    ". ." 8px
    "Summary ." min-content
    / auto 120px;
  column-gap: 10px;
  justify-content: space-between;
  align-items: center;

  inline-size: 100%;
  padding-block: 16px;
  padding-inline: 20px;

  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontMerriweather};
  font-style: normal;
  line-height: normal;

  background-color: #2c4692;

  box-shadow: 0 -4px 4px 0 rgba(0, 0, 0, 0.25);

  font-feature-settings:
    "liga" off,
    "clig" off;

  ${FooterText} {
    grid-area: Text;
  }
  ${FooterTitle} {
    grid-area: Title;
  }
  ${Summary} {
    grid-area: Summary;
  }
  ${StyledSignUpButton} {
    grid-area: SignUpButton;
  }
`;

export const Container = styled.div`
  position: relative;

  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;

  block-size: calc(100vh - 46px);
`;

export const StyledIframe = styled.iframe`
  inline-size: 100%;
  block-size: calc(100vh - 56px);
  margin-block-end: 100px;
  padding-inline: 20px;
`;
